import React from "react";
import { useTranslation } from "react-i18next";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";

import PublicIcon from "@mui/icons-material/Public";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import ShareIcon from "@mui/icons-material/Share";

import NavigationItem from "./NavigationItem";
import ContextList from "./ContextList";
import useAccountSettings from "../../ManageAccount/useAccountSettings";
import JoinGroupButton from "./JoinGroupButton";

function NavigationList() {
  const [openContext, setOpenContext] = React.useState(true);
  const { accountSettings } = useAccountSettings();
  const { t } = useTranslation();

  const libraryMenuOptions = [
    {
      id: "public",
      icon: <PublicIcon />,
      title: t("library.buttons.public"),
      to: "/library/public",
      disabled: accountSettings.disablePublicLibrary,
    },
    {
      id: "local",
      icon: <BookmarkBorderIcon />,
      title: t("library.buttons.my"),
      to: "/library/local",
      disabled: false,
    },
    {
      id: "contexts",
      icon: <ShareIcon />,
      title: t("library.buttons.shared"),
      to: "/library/contexts",
      disabled: false,
    },
  ];

  const toggleContext = () => setOpenContext((prev) => !prev);

  return (
    <List sx={{ padding: 2 }}>
      {libraryMenuOptions
        .filter((option) => !option.disabled)
        .map((option) => (
          <NavigationItem
            key={option.id}
            option={option}
            toggleContext={toggleContext}
            openContext={openContext}
          />
        ))}
      <Collapse in={openContext} timeout="auto" unmountOnExit>
        <ContextList />
      </Collapse>
      {accountSettings.disableContextSubscription ? null : <JoinGroupButton />}
    </List>
  );
}

export default NavigationList;
